export const ExperiencesActionTypes = {
  API_RESPONSE_SUCCESS: '@@experiences/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@experiences/API_RESPONSE_ERROR',

  GET_EXPERIENCE: '@@experiences/GET_EXPERIENCE',
  LIST_EXPERIENCES: '@@experiences/LIST_EXPERIENCES',
  ADD_EXPERIENCE: '@@experiences/ADD_EXPERIENCE',
  UPDATE_EXPERIENCE: '@@experiences/UPDATE_EXPERIENCE',
  DELETE_EXPERIENCE: '@@experiences/DELETE_EXPERIENCE',
  SET_FILTER: '@@experiences/SET_FILTER',

  RESET: '@@experiences/RESET'
}
